import { frontendURL } from '../../../../helper/URLHelper';
import { ACCOUNT_PERMISSIONS } from 'dashboard/constants/permissions.js';
const Index = () => import('./Index.vue');
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/general'),
      meta: {
        permissions: ['administrator', ACCOUNT_PERMISSIONS],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'general_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator', ACCOUNT_PERMISSIONS],
          },
        },
      ],
    },
  ],
};
